import ImagesMainBannerAboutdrinksSvg from '@/public/images/main-banner/aboutdrinks.svg';
import ImagesMainBannerBuyOrSellSpiritsBgSvg from '@/public/images/main-banner/buyOrSellSpiritsBg.svg';
import ImagesMainBannerCosmopolitanSvg from '@/public/images/main-banner/cosmopolitan.svg';
import ImagesMainBannerFeaturedInSvg from '@/public/images/main-banner/featured-in.svg';
import ImagesMainBannerHandelsblattSvg from '@/public/images/main-banner/handelsblatt.svg';
import ImagesMainBannerInvestWebp from '@/public/images/main-banner/invest.webp';
import ImagesMainBannerMainBannerWebp from '@/public/images/main-banner/mainBanner.webp';
import ImagesMainBannerWhiskyExpertsSvg from '@/public/images/main-banner/whiskyExperts.svg';
import ImagesMainBannerWinABottleEachMonthWebp from '@/public/images/main-banner/win-a-bottle-each-month.webp';

export {
  ImagesMainBannerAboutdrinksSvg,
  ImagesMainBannerBuyOrSellSpiritsBgSvg,
  ImagesMainBannerCosmopolitanSvg,
  ImagesMainBannerFeaturedInSvg,
  ImagesMainBannerHandelsblattSvg,
  ImagesMainBannerInvestWebp,
  ImagesMainBannerMainBannerWebp,
  ImagesMainBannerWhiskyExpertsSvg,
  ImagesMainBannerWinABottleEachMonthWebp,
};
